// extracted by mini-css-extract-plugin
export default {"container":"_c2573928","header":"_63dcd930","subheader":"_5e4807f4","icon":"_7497ba24","link":"_1536672f"};